module.exports = __webpack_public_path__ + "static/media/Wahid.19a5e95d.jpg";